/* istanbul ignore file */
export enum ThumbnailOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export interface ProductImagesState {
  navigatedBy: 'swipe' | 'click' | null;
  currentImage: number;
  lastImage: number;
  isModalOpen: boolean;
}

export type ImagesLocation = 'Expanded image' | 'Main image' | 'Carousel';

export interface SetCurrentImagePayload {
  imageIndex: number;
  navigationType: ProductImagesState['navigatedBy'];
  location?: ImagesLocation;
}

export interface OpenModalPayload {
  location: ImagesLocation;
}

export interface NextOrPreviousPayload {
  location: ImagesLocation;
}
